declare global {
  const __APP_ENV__: string | undefined;
}

export function isDev() {
  return ["development", "test"].includes(process.env.__APP_ENV__ ?? "");
}
